// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as List from "bs-platform/lib/es6/list.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Envelope$WebAudio from "../Envelope/Envelope.bs.js";
import * as AppContextProvider$WebAudio from "./AppContextProvider.bs.js";

function Keyboard(Props) {
  var appContext = React.useContext(AppContextProvider$WebAudio.appContext);
  var match = React.useState(function () {
        return false;
      });
  var setKeyPress = match[1];
  var trigger = function (e) {
    if (e.key === "a") {
      return Curry._1(setKeyPress, (function (key) {
                    if (key === false) {
                      List.iter(Envelope$WebAudio.trigger, appContext.triggerTargets);
                      return true;
                    } else {
                      return true;
                    }
                  }));
    }
    
  };
  var endTrigger = function (e) {
    if (e.key === "a") {
      return Curry._1(setKeyPress, (function (param) {
                    List.iter(Envelope$WebAudio.endTrigger, appContext.triggerTargets);
                    return false;
                  }));
    }
    
  };
  React.useEffect((function () {
          document.addEventListener("keydown", trigger);
          document.addEventListener("keyup", endTrigger);
          return (function (param) {
                    document.removeEventListener("keydown", trigger);
                    document.removeEventListener("keydown", endTrigger);
                    
                  });
        }), [appContext.triggerTargets]);
  return null;
}

var make = Keyboard;

export {
  make ,
  
}
/* react Not a pure module */
